<template>
    <!-- 手动交易 -->
    <el-dialog title="手动交易" :visible.sync="manualFlag" class="uu-manul-dialog">
        <el-form label-width="120px">
            <el-form-item label="委托价格($)">
                <el-input v-model="manualParam.price"></el-input>
            </el-form-item>
            <el-form-item label="委托量(张)">
                <el-input v-model="manualParam.amount" placeholder="期货时，单位为张，现货为颗"></el-input>
            </el-form-item>
            <el-form-item label="合约类型">
                <el-select v-model="manualParam.type" placeholder="请选择合约类型" @change="tradeChangeEvent">
                    <el-option v-for="(trade, index) in tradeTypeObj" :key="'trade'+index" :label="trade" :value="index"
                    :disabled="isBan(index)"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="币对" v-if="type == 'temp'">
                <!-- <el-input class="match_input" v-model="manualParam.symbol" @input="matchValue" @blur="loseForce"
                placeholder="请输入币对"></el-input>
                <ul class="input_dropdown" style="display: none;">
                    <li v-for="(i, index) in currencyMatchList" :key="'match_'+index" 
                    @click="currencySelect(i)">{{i}}</li>
                </ul> -->

                <el-input class="match_input" :disabled="true" v-model="manualParam.symbol" placeholder="请输入币对"></el-input>
            </el-form-item>
            <el-form-item label="交易类型">
                <el-select v-model="manualParam.direction" placeholder="请选择交易类型">
                    <el-option v-for="(trade, index) in tradeDirection" :key="'trade'+index" :label="index" :value="trade"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="下单方式">
                <el-select v-model="manualParam.way" placeholder="请选择交易方向">
                    <el-option label="市价" value="1"></el-option>
                    <el-option label="限价" value="0"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="manualFlag = false">取消</el-button>
            <el-button type="primary" @click="submitManual">确定</el-button>
        </div>
    </el-dialog>
</template>


<script>
import { mapState } from "vuex";
import { post, get } from "@/api/index";

export default {
    data: function () {
        return {
            manualFlag: false,
            manualParam: {},
            tradeDirection: '',
            currencys: {},
            thisBourse: '',
        }
    },
    props: {
        type: {
            type: String,
            required: true
        }
    },
    mounted() {

    },
    watch: {

    },
    computed: {
        ...mapState([
            "tradeTypeObj",
            "token"
        ]),
    },
    methods: {
        showDialog() {// 窗口展示
            this.manualFlag = true;
        },
        
        tradeChangeEvent(e) {// 交易类型 切换事件
            if (e == 'SS') {// 现货
                this.tradeDirection = {"买": 1, "卖": 2};
            } else {
                this.tradeDirection = {'开多': 1,"开空": 2, "平多": 3, "平空": 4};
            }

            if (this.type == 'temp') {

            } else {
                this.getCurrencys(e);
            }
        },

        getCurrencys(tps) {// 获取币对
            var url = this.$url_LN_local + '/get/currency/information';
            var param = {
                "bourse": this.apiData.name,
                "types": tps
            };

            get(url, param).then(res => {
                if (res.code == 200) {
                    this.currencys = res.data;
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    });
                }
            });
        },

        currencySelect(cur) {// 币对选择事件
            this.manualParam.symbol = cur;
            $('.input_dropdown').css('display', 'none');
        },

        submitManual() {// 手动（新）提交
            var url = this.$url_temp + '/manual/trading';
            var param = this.manualParam;
            param['apiId'] = this.apiData.aid;

            post(url, JSON.stringify(param)).then(res => {
                if (res.code === 200) {
                    this.manualFlag = false;
                    this.$notify.info({
                        message: '操作成功',
                        title: '提示',
                        offset: 100
                    })
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: "提示",
                        offset: 100
                    })
                }
            });

        },

        setDialogData(data) {// 设置dialog 数据
            this.apiData = data;
            this.manualParam['symbol'] = this.apiData.currency;
        },

        isBan(col) {// 交易类型下拉框禁止选择
            if (col == 'CQ') {// 季度
                return false;
            } else {
                return true;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
